import { createApi } from '@reduxjs/toolkit/query/react';
//
import { customBaseQuery } from '../../auth/context/jwt/utils';
import { IService, IServiceCreate, IServicePage } from '../../types/service';

const path = 'services';

type UpdateProps = {
  data: IServiceCreate;
  id: number;
};

export const serviceService = createApi({
  reducerPath: 'serviceService',
  tagTypes: ['services'],
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    getServices: builder.query<IServicePage, Record<string, any>>({
      query: (params) => ({
        url: `/${path}/list`,
        params,
      }),
      providesTags: ['services'],
    }),

    getService: builder.query<IService, number>({
      query: (id: number) => ({
        url: `/${path}/findById/${id}`,
        method: 'GET',
      }),
      providesTags: (_result, _error, id) => [{ type: 'services', id }],
    }),

    getNextCode: builder.query<{ code: string }, void>({
      query: () => ({
        url: `/${path}/nextCode`,
        method: 'GET',
      }),
    }),

    saveService: builder.mutation<IService, IServiceCreate>({
      query: (service: IServiceCreate) => ({
        url: `/${path}/insert`,
        method: 'POST',
        body: service,
      }),
      invalidatesTags: ['services'],
    }),

    updateService: builder.mutation<IService, UpdateProps>({
      query: ({ id, data }: UpdateProps) => ({
        url: `/${path}/update/${id}`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: (_result, _error, { id }) => ['services', { type: 'services', id }],
    }),

    deleteService: builder.mutation<{ message: string }, number>({
      query: (id: number) => ({
        url: `/${path}/delete/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['services'],
    }),

    toggleServiceStatus: builder.mutation<IService, number>({
      query: (id: number) => ({
        url: `/${path}/${id}/toggle-status`,
        method: 'PATCH',
      }),
      invalidatesTags: ['services'],
    }),
  }),
});

export const {
  useGetServicesQuery,
  useGetServiceQuery,
  useLazyGetServiceQuery,
  useGetNextCodeQuery,
  useSaveServiceMutation,
  useUpdateServiceMutation,
  useDeleteServiceMutation,
  useToggleServiceStatusMutation,
} = serviceService;
